import { MESSAGE_TEMPLATE_DELETE, MESSAGE_TEMPLATE_GET, MESSAGE_TEMPLATE_POST, MESSAGE_TEMPLATE_STATUS, MESSAGE_TEMPLATES_LIST_GET_DATA } from "./Constants";

const initialState = {
  loading: false,
  loadingMsgData: false,
  error: null,
  msgTemplatesList: [],
  templateDetail: null,

};

const initialMessageTemplatePostState = {
  loading: false,
  success: false,
  error: null,
  createdTemplate: null,
};

const initialMsgTemplatesActionState = {
  loading: false,
  error: null,
  success: false,
};
const msgTemplatesListReducer = (state = initialState, action) => {
  switch (action.type) {

    // LOAD
    case MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    // SUCCESS
    case MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        msgTemplatesList: action.payload, // THIS IS THE DATA
        error: null,
      };


    // FAIL
    case MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_LOAD:
      return {
        ...state,
        loadingMsgData: true,
        error: null,
        templateDetail: null,
      };

    case MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_SUCCESS:
      return {
        ...state,
        loadingMsgData: false,
        templateDetail: action.payload,
        error: null,
      };

    case MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_FAIL:
      return {
        ...state,
        loadingMsgData: false,
        error: action.error,
      };
case MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_CLEAR:
  return {
    ...state,              // KEEP EXISTING LIST
    loadingMsgData: false,
    error: null,
    templateDetail: null,  // reset only detail
  };


    default:
      return state;
  }
};

const messageTemplatePostReducer = (state = initialMessageTemplatePostState, action) => {
  switch (action.type) {

    case MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_LOAD:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_UPDATE_LOAD:
      return { ...state, loading: true, success: false,
        error: null, };

    case MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        createdTemplate: action.payload,
        error: null,
      };

    case MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };

    default:
      return state;
  }
};

const messageTemplateActionReducer = (state = initialMsgTemplatesActionState, action) => {
  switch (action.type) {

    /* ========= DELETE ========= */
    case MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_LOAD:
      return { ...state, loading: true, success: false };

    case MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_SUCCESS:
      return { ...state, loading: false, success: true };

    case MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_FAIL:
      return { ...state, loading: false, error: action.error };

    /* ========= STATUS ========= */
    case MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_LOAD:
      return { ...state, loading: true, success: false };

    case MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_FAIL:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export { msgTemplatesListReducer, messageTemplatePostReducer, messageTemplateActionReducer };
